var _path, _path2, _path3, _path4, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_22246)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M58.5431 11.666C33.7831 11.666 13.7031 31.736 13.7031 56.506C13.7031 81.276 33.7831 101.346 58.5431 101.346C83.3031 101.346 103.383 81.266 103.383 56.506C103.383 31.746 83.3131 11.666 58.5431 11.666Z",
    fill: "url(#paint0_radial_164_22246)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.833 11.3848C31.293 11.3848 10.583 32.0848 10.583 57.6348C10.583 83.1848 31.293 103.885 56.833 103.885C82.373 103.885 103.083 83.1748 103.083 57.6348C103.083 32.0948 82.373 11.3848 56.833 11.3848Z",
    fill: "url(#paint1_linear_164_22246)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.833 11.3848C31.293 11.3848 10.583 32.0848 10.583 57.6348C10.583 83.1848 31.293 103.885 56.833 103.885C82.373 103.885 103.083 83.1748 103.083 57.6348C103.083 32.0948 82.373 11.3848 56.833 11.3848Z",
    fill: "#516CD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.833 11.3848C31.293 11.3848 10.583 32.0848 10.583 57.6348C10.583 83.1848 31.293 103.885 56.833 103.885C82.373 103.885 103.083 83.1748 103.083 57.6348C103.083 32.0948 82.373 11.3848 56.833 11.3848Z",
    fill: "url(#paint2_radial_164_22246)",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.833 11.3848C31.293 11.3848 10.583 32.0848 10.583 57.6348C10.583 83.1848 31.293 103.885 56.833 103.885C82.373 103.885 103.083 83.1748 103.083 57.6348C103.083 32.0948 82.373 11.3848 56.833 11.3848Z",
    fill: "url(#paint3_radial_164_22246)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M56.8234 11.666C32.0534 11.666 11.9834 31.736 11.9834 56.506C11.9834 81.276 32.0634 101.346 56.8234 101.346C81.5834 101.346 101.673 81.266 101.673 56.506C101.673 31.746 81.5934 11.666 56.8234 11.666Z",
    fill: "url(#paint4_radial_164_22246)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_164_22246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7997 32H61.5997C72.4245 32 81.1997 41.0002 81.1997 52.1026C81.1997 63.205 72.4245 72.2051 61.5997 72.2051V81C49.3497 75.9744 32.1997 68.4359 32.1997 52.1026C32.1997 41.0002 40.9749 32 51.7997 32ZM56.6997 67.1795H61.5997C69.7183 67.1795 76.2997 60.4293 76.2997 52.1026C76.2997 43.7758 69.7183 37.0256 61.5997 37.0256H51.7997C43.6811 37.0256 37.0997 43.7758 37.0997 52.1026C37.0997 61.1738 43.1318 67.093 56.6997 73.4108V67.1795Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_164_22246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8332 12.6055C81.0432 12.6055 100.733 32.2955 100.733 56.5055C100.733 80.7155 81.0432 100.406 56.8332 100.406C32.6232 100.406 12.9332 80.7056 12.9332 56.5055C12.9332 32.3055 32.6232 12.6055 56.8332 12.6055ZM56.8332 7.43555C29.7332 7.43555 7.76318 29.4055 7.76318 56.5055C7.76318 83.6055 29.7332 105.576 56.8332 105.576C83.9332 105.576 105.903 83.6055 105.903 56.5055C105.903 29.4055 83.9332 7.43555 56.8332 7.43555Z",
    fill: "url(#paint5_linear_164_22246)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_22246",
    x: 30.1997,
    y: 32,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_22246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_22246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_164_22246",
    x: 3.76318,
    y: 7.43555,
    width: 106.14,
    height: 106.141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_22246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_22246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_164_22246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2735 59.2914) scale(50.3982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D0D6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3B5565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_22246",
    x1: 27.193,
    y1: 22.1348,
    x2: 86.483,
    y2: 93.1348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#312A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#756A74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_164_22246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9927 30.6556) rotate(51.0441) scale(77.6487 77.6487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_164_22246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.4118 92.3223) rotate(-93.6705) scale(79.1728 88.2414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34499C",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#516CD3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopColor: "#516CD3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_164_22246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.7348 55.905) scale(43.9926 43.9926)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ECF2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BDD1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#719CB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0A5478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004D73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_164_22246",
    x1: 25.3832,
    y1: 18.8355,
    x2: 88.2832,
    y2: 94.1656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_22246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 113,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOption);
export default __webpack_public_path__ + "static/media/ChatOption.651b69e1bd24847fb96ef83670f422c9.svg";
export { ForwardRef as ReactComponent };